import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=81aaa7f8&scoped=true&"
import script from "./LandingPage.vue?vue&type=script&lang=js&"
export * from "./LandingPage.vue?vue&type=script&lang=js&"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=81aaa7f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aaa7f8",
  null
  
)

export default component.exports